import { NgClass } from '@angular/common';
import { Component, HostListener, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Steper } from '@shared/interfaces/stepers.interface';

@Component({
  selector: 'app-stepers',
  standalone: true,
  imports: [NgClass],
  templateUrl: './stepers.component.html',
  styleUrl: './stepers.component.css',
})
export class StepersComponent implements OnInit {
  @Input() listSteps: Steper[] = [];

  isMobile = false;

  private router = inject(Router);

  ngOnInit() {
    this.checkWindowWidth();
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkWindowWidth();
  }

  checkWindowWidth() {
    this.isMobile = window.innerWidth >= 1390;
  }

  goToStep(step: number) {
    this.listSteps.forEach((item, index) => {
      if (!item.disabled) {
        if (index === step) {
          item.select = true;
          item.filled = false;
        } else if (index !== step) {
          item.select = false;
          item.filled = true;
        }
      }
    });
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    this.router.navigate([this.listSteps[step].link]);
  }
}
